import { polyfill } from 'es6-promise'
import 'isomorphic-fetch' // fetch Polyfill
import 'url-polyfill'

import 'regenerator-runtime/runtime' // URL() polyfill
polyfill()

// forEach Polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
}
